import { Component, OnDestroy, Input } from '@angular/core';
import 'rxjs/add/observable/forkJoin';

@Component({
  selector: 'app-backdrop-bloqueio',
  templateUrl: './backdrop-bloqueio.component.html',
  styleUrls: ['./backdrop-bloqueio.component.scss']
})
export class BackdropBloqueioComponent implements OnDestroy {
  @Input() mostrarBloqueio = false;

  ngOnDestroy(): void {
    this.mostrarBloqueio = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/checkout/components/checkout/backdrop-bloqueio/backdrop-bloqueio.component.ts